import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=8643fe24&scoped=true"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=8643fe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8643fe24",
  null
  
)

export default component.exports